import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_KEYWORD_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientKeywordsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_KEYWORD_DETAILS } from '../redux/action-types'

const useUpdateIngredientKeywordDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredient?.keywords?.main || {},
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_KEYWORD_DETAILS_MUTATION,
        { id, data: transformToUpdateIngredientKeywordsArgs(id, data) },
        dispatch,
        UPDATE_INGREDIENT_KEYWORD_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateIngredientKeywordDetailsMutation
